import config from 'services/table/const';
import WeightRanges from 'ui/screens/onboarding/pricing/component/weight.ranges';
import { currencyFormat } from 'utilities/common';
import Action from './table.action';

let table = { ...config };

table.url = '/tms/pricing';
table.filter = { type: 'global' };
table.columns = {
    service_type: {
        title: 'Tipe Layanan',
        sortable: true,
        width: 100,
        component: (row) => {
            return (
                <div className="table-col">
                    <div className="text-ellipsis fs-8 fw-semibold text-uppercase">{row?.service_type?.name}</div>
                    <small className="info text-uppercase">
                        {row?.service_type?.service?.name}
                    </small>
                </div>
            );
        },
    },
    origin_id: {
        title: 'Asal',
        sortable: false,
        width: 100,
        component: (row) => {
            return (
                <div className="table-col">
                    <small className="info text-uppercase text-ellipsis">
                        {row?.origin?.village_name
                            ? `${row?.origin?.village_name}, ${row?.origin?.district_name}, ${row?.origin?.regency_name}, ${row?.origin?.province_name}`
                            : row?.origin?.district_name
                                ? `${row?.origin?.district_name}, ${row?.origin?.regency_name}, ${row?.origin?.province_name}`
                                : row?.origin?.regency_name
                                    ? `${row?.origin?.regency_name}, ${row?.origin?.province_name}`
                                    : `${row?.origin?.province_name}`}
                    </small>
                </div>
            );
        },
    },
    destination_id: {
        title: 'Tujuan',
        sortable: false,
        width: 100,
        component: (row) => {
            return (
                <div className="table-col">
                    <small className="info text-uppercase text-ellipsis">
                        {row?.destination?.village_name
                            ? `${row?.destination?.village_name}, ${row?.destination?.district_name}, ${row?.destination?.regency_name}, ${row?.destination?.province_name}`
                            : row?.destination?.district_name
                                ? `${row?.destination?.district_name}, ${row?.destination?.regency_name}, ${row?.destination?.province_name}`
                                : row?.destination?.regency_name
                                    ? `${row?.destination?.regency_name}, ${row?.destination?.province_name}`
                                    : `${row?.destination?.province_name}`}
                    </small>
                </div>
            );
        },
    },
    nlv: {
        title: 'Harga',
        sortable: false,
        width: 100,
        class: 'text-end',
        classHeader: 'text-end',
        component: (row) => {
            return row?.pricing_schema === 'weight_point_based' ? (
                <WeightRanges data={row} />
            ) : (
                <div>{currencyFormat(row?.nlv, false)}</div>
            );
        },
    },
    action: {
        title: '',
        width: 70,
        class: 'text-end',
        component: (row) => {
            return <Action data={row} customer_id={row?.customer?.id} />;
        },
    },
};

export default table;
